import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { durationExperience, flagByLanguageNameExperience, getExtrasExperience, languageArrayExperience, periodsArrExperience } from './activities-result-function';
import { getCommentadjective } from '../hotel-result/hotel-result-funtions';


interface GroupedAmenity {
  icon: string;
  names: string[];
  descriptions: string[];
}

@Component({
  selector: 'usb-activities-result',
  templateUrl: './activities-result.component.html',
  styleUrls: ["../../../base-result.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class ActivitiesResultComponent implements OnInit {

  @Input() result: any;
  @Input() clientsSettingAppBooking: any;

  @Output() openModalEmit = new EventEmitter();

  constructor(
            ) { }

  ngOnInit() {
  }

  getDurations(product: any): string {
    return durationExperience(product);
  }

  periodsActivities(product: any): string {
    return periodsArrExperience(product?.additionalInfo?.tours?.options);
  }

  getLanguages(product: any): string {
     const languages = this.getLanguageArray(product?.additionalInfo?.tours?.options);
     return languages.join(', ');
  }

  getLanguageArray(options: any): any[] {
    return languageArrayExperience(options)
  }

  getFlagByLanguageName(language: any): any {
    return flagByLanguageNameExperience(language);
  }



  getCommentadjective(average: any): any {
    return getCommentadjective(average);
  }

    openModal(typeModal: string): void {
        this.openModalEmit.emit(typeModal);
  }

    getAddons(extras: any[]): any[] {
      return getExtrasExperience(extras);
    }

}
